import { Button, Typography } from "@mui/material"
import { Link } from "react-router-dom"

export default function CreateAccountButton() {
    const LoginLink = props => <Link to="/create-account" {...props} />
    return (
        <Button
            component={LoginLink}
            variant="contained"
            disableElevation
            color="secondary"
            size="small"
            sx={{ color: "white", borderRadius: "1rem", marginLeft: ".5rem" }}>
            <Typography variant="body1">Create Account</Typography>
        </Button>
    )
}